import { Injectable } from '@angular/core';
import { Adapter } from './adapter';
import merge from 'lodash/merge'

export class Customer {
    public Customer_ID: any = null;
    public Customer_Code: any = null;
    public Customer_Name: any = '';
    public Customer_LegalName: any = null;
    public CustomerTradeMode_ID: any = null;
    public TradeMode_Desc: any = null;
// 21/2
    public Customer_StateID: any = null;
    public Customer_Address1: any = null;
    public CustomerClassification_Name: any = null;
    public CustBillHistory: any = null;
    public Address_Type: any = null;
    public customerAddressTypeList: any[] = [];
//
    public Active: any = null;
    public Customer_RecoGLID: any = null;
    public Customer_Status: any = null;
    public CustomerReason_ID: any = null;
    public Customer_StatusReason: any = null;
    public CustomerClassification_ID: any = null;
    public State_Desc: any = null;
    public Salesman_ID: any = null;
    public Salesman_Name: any = null;
    public DistChnl_ID: any = null;
    public Unit_ID: any = null;
    public Route_ID: any = null;
    public Form_ID: any = null;
    public Quarter_Scheme: any = null;
    public Half_Scheme: any = null;
    public Full_Scheme: any = null;
    public CreatedBy: any = null;
    public CreatedOn: any = null;
    public ModifiedBy: any = null;
    public ModifiedOn: any = null;
    public Customer_Contact = null;
    public Customer_Mobile = null;
    public Customer_EmailID = null;
    public Customer_SendMail = null;
    public contactActive = null;
    
    // constructor(public Customer_ID, public Customer_Code, public Customer_Name, public Customer_LegalName, public CustomerTradeMode_ID, public Active, public Customer_RecoGLID, public Customer_Status, public CustomerReason_ID, public Customer_StatusReason, public CustomerClassification_ID, public DistChnl_ID, public Unit_ID, public Route_ID, public Form_ID, public CreatedBy, public CreatedOn, public ModifiedBy, public ModifiedOn) {
    // }

    constructor() {

    }

    add(initVal: Partial<Customer>): Customer {
        Object.assign(this, initVal);
        return this;
    }
    
    update(obj): Customer{
        return merge(this, obj);
    }

    getInstance(){
        return this;
    }
}

@Injectable()
export class CustomerAdapter implements Adapter<Customer> {
    adapt(item: any): Customer {
        return new Customer().add(item);
    }
}
